import { get, post } from "helpers/api_helper"
import { toast } from "react-toastify"

export async function getPublications({
  page = 1,
  size,
  setTableData,
  setCurrentPage,
  setTotalPages,
  setLoading,
  setTotalItems,
  setFilteredIds,
  startDate,
  endDate,
  text,
}) {
  const url =
    `${process.env.REACT_APP_API_INT_LEADS}/api/resultados-publicacao-final/filter`
  const payload = { page, pageSize: size, startDate, endDate, text }

  try {
    const response = await post(url, payload)

    setTableData(response.data)
    setCurrentPage(response.currentPage)
    setTotalPages(response.totalPages)
    setTotalItems(response.totalItems)
    setFilteredIds(response?.ids || [])
  } catch (error) {
    toast.error(error.response.data.message)
  } finally {
    setLoading(false)
  }
}

export async function getProcesses({
  page = 1,
  size = 10,
  setTableData,
  setCurrentPage,
  setTotalPages,
  setLoading,
  setTotalItems,
  setFilteredIds,
  startDate, // não usado por enquanto
  endDate,   // não usado por enquanto
  text,      // não usado por enquanto
}) {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(size),
    includePublicacoes: "false",
  })
  const url = `${process.env.REACT_APP_API_INT_LEADS}/api/processos/paged?${params.toString()}`

  try {
    const response = await get(url)

    // Suporta múltiplos formatos comuns de resposta
    const items = response?.data ?? []

    const current = response?.currentPage ?? page
    const totalItemsResp = response?.totalItems ?? items.length
    const totalPagesResp = response?.totalPages ?? Math.max(1, Math.ceil(totalItemsResp / size))

    setTableData(items)
    setCurrentPage(current)
    setTotalPages(totalPagesResp)
    setTotalItems(totalItemsResp)
    setFilteredIds(items.map(item => item?.Id ?? item?.id).filter(Boolean))
  } catch (error) {
    console.error("Erro ao buscar processos", error)
  } finally {
    setLoading(false)
  }
}

export async function getPublicationsByText({
  text,
  page = 1,
  size = 10,
  setTableData,
  setCurrentPage,
  setTotalPages,
  setLoading,
  setTotalItems,
  setFilteredIds,
}) {
  const url = `${process.env.REACT_APP_API_INT_LEADS}/api/publicacoes/filter-texto`
  const payload = { text, page, pageSize: size, mode: "contains" }

  try {
    const response = await post(url, payload)

    const items = response?.data ?? []
    const current = response?.currentPage ?? page
    const totalItemsResp = response?.totalItems ?? items.length
    const totalPagesResp = response?.totalPages ?? Math.max(1, Math.ceil(totalItemsResp / size))

    setTableData(items)
    setCurrentPage(current)
    setTotalPages(totalPagesResp)
    setTotalItems(totalItemsResp)
    setFilteredIds((response?.ids ?? items.map(item => item?.Id ?? item?.id)).filter(Boolean))
  } catch (error) {
    console.error("Erro ao filtrar publicações por texto", error)
    toast.error(error?.response?.data?.message || "Erro ao filtrar publicações")
  } finally {
    setLoading(false)
  }
}

export async function postAnalise({ rowsSelected, analise }) {
  const url =
    `${process.env.REACT_APP_API_INT_LEADS}/api/resultados-publicacao-final/analisar`
    const payload = { items: rowsSelected, analisar: analise }

  try {
    const response = await post(url, payload)

    return response.message
  } catch (error) {
    console.error("Erro ao analisar", error)
  }
}

export async function getTags(setTags) {
  const url = `${process.env.REACT_APP_API_INT_LEADS}/api/tags`

  try {
    const response = await get(url)

    const uniqueTags = Array.from(
      new Map(response.map(tag => [tag.Titulo, tag])).values()
    )

    const tagsData = uniqueTags.map(tag => ({
      id: tag.Id,
      title: tag.Titulo,
    }))

    setTags(tagsData)
  } catch (error) {
    console.error("Erro ao buscar tags", error)
  }
}
